import React from 'react';

import { css, cx } from '@emotion/css';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useStyles } from '@/hooks/useStyles.ts';
import { useChatMessagingState } from '@/uiKit/organisms/ChatMessaging/ChatMessagingState.ts';

export type ChatVisibilitySelectorProps = {
  className?: string;
};

export const ChatVisibilitySelector: React.FC<ChatVisibilitySelectorProps> = ({
  className,
}) => {
  const chatState = useChatMessagingState(state => state);
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <div className={cx(styles.container, className)}>
      <Tabs
        value={chatState.visibility}
        className={styles.tabs}
        onChange={(_, value) => value && chatState.setVisibility(value)}
        variant="scrollable"
        scrollButtons="auto"
      >
        <Tab label={t('messaging.all')} value="all" />
        <Tab label={t('messaging.medicalStaff')} value="practitioners" />
      </Tabs>
    </div>
  );
};

const makeStyles = () => ({
  container: css({}),
  tabs: css({
    '.MuiTabs-scroller': {
      alignSelf: 'center',
    },
  }),
});
